import { useTranslation } from "react-i18next";
import NewDialog, { NewDialogProps } from "../NewDialog/NewDialog";

import styles from "./CancelPauseDialog.module.scss";
import Actions from "../CancellationDialog/components/Actions";
import Button from "../CancellationDialog/components/Button";
import Body from "./Body";

interface CancelPauseDialogProps extends NewDialogProps {
  onCancel: () => void;
}

const CancelPauseDialog = (props: CancelPauseDialogProps) => {
  const { t } = useTranslation("translations");

  const onDone = () => {
    props.onCancel();
  };

  return (
    <NewDialog className={styles.dialog} destroyOnClose {...props}>
      <div className={styles.centerWrapper}>
        <Body
          title={t(
            "web_my_account_subscription_cancel_pause_confirmation_header"
          )}
          subtitle={t(
            "web_my_account_subscription_cancel_pause_confirmation_body"
          )}
        >
          <Actions>
            <Button variant="secondary" onClick={onDone}>
              {t("web_subscription_memory_lane_done_button")}
            </Button>
          </Actions>
        </Body>
      </div>
    </NewDialog>
  );
};

export default CancelPauseDialog;
